import { ListItemText } from "@mui/material";

// src/utils/shoppingListUtils.js
export const generateShoppingList = (menuPlans, recipes) => {
  // Build an object where each key is the ingredient name.
  const ingredientGroups = {};

  menuPlans.forEach(({ recipeId, day, meal }) => {
    const recipe = recipes.find((r) => Number(r.id) === Number(recipeId));
    if (recipe) {
      recipe.ingredients.forEach(({ name, quantity, unit, notes }) => {
        const key = name.trim().toLowerCase();
        if (!ingredientGroups[key]) {
          ingredientGroups[key] = {
            name,
            entries: [],
          };
        }
        ingredientGroups[key].entries.push({
          quantity: Number(quantity),
          unit: unit.trim().toLowerCase(),
          notes,
          recipe: { id: recipe.id, title: recipe.title, day, meal },
        });
      });
    }
  });

  // Convert the grouped object into a list.
  return Object.values(ingredientGroups).map((group) => {
    // Detect if there are conflicting units.
    const unitsUsed = [...new Set(group.entries.map((entry) => entry.unit))];
    return {
      ...group,
      conflict: unitsUsed.length > 1,
      // You can either choose to keep an array of entries,
      // or if there is only one unit, you can sum the quantity.
      quantity: unitsUsed.length === 1 ? group.entries.reduce((acc, entry) => acc + entry.quantity, 0) : null,
      unit: unitsUsed.length === 1 ? unitsUsed[0] : null,
    };
  });
};

const formatRecipes = (recipes, t) => {
  const recipeMap = new Map();
  recipes?.forEach(({ title, day, meal }) => {
    if (!title) return; // guard against missing fields
    if (!recipeMap.has(title)) {
      recipeMap.set(title, []);
    }

    let timeStr = "";
    if (day) {
      timeStr += t(`tableHeaders.daysOfWeek.${day}`);
    }
    if (day && meal) {
      timeStr += " ";
    }
    if (meal) {
      timeStr += t(`tableHeaders.mealTimes.${meal}`);
    }

    if (timeStr) {
      recipeMap.get(title).push(timeStr);
    }
  });

  // Turn the map into a comma-separated string
  return Array.from(recipeMap.entries())
    .map(([title, times]) => {
      if (times.length > 0) {
        return `${title} (${times.join(", ")})`;
      }
      return title;
    })
    .join(", ");
};

export const renderListItemText = (item, t, name) => {
  if (!item) return null;
  if (!name) name = item.name;
  return (
    <ListItemText
      primary={`${name} - ${item.quantity} ${item.unit}`}
      secondary={
        <>
          {item.notes && item.notes.length > 0 && (
            <>
              {t("notes")}: {item.notes}
              <br />
            </>
          )}
          {item.recipes?.length > 0 && (
            <>
              {t("usedIn")}: {formatRecipes(item.recipes, t)}
            </>
          )}
        </>
      }
    />
  );
};
